import React from 'react';
import Text from 'components/Text/Text';
import { Checkbox, Form } from 'antd';
import style from './SendDeviceUnavailabilityAlerts.module.scss';

interface IProps {
	toggleSendDeviceUnavailabilityAlerts: () => void;
	sendDeviceUnavailabilityAlerts: boolean;
}

const SendDeviceUnavailabilityAlerts: React.FC<IProps> = ({
	toggleSendDeviceUnavailabilityAlerts,
	sendDeviceUnavailabilityAlerts,
}) => {
	return (
		<Form.Item className={style.container} name="sendDeviceUnavailabilityAlerts">
			<Checkbox checked={sendDeviceUnavailabilityAlerts} onChange={toggleSendDeviceUnavailabilityAlerts}>
				<Text
					translationNameSpace="form"
					translationKey="sendDeviceUnavailabilityAlertsLabel"
					asFragment={true}
				/>
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(SendDeviceUnavailabilityAlerts);
